import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { formatDate, formatToDate } from "../master/FormatToDateTime";
import usePrivateLink from "../config/usePrivateLink";
import Swal from "sweetalert2";
import {
  studentFeeTransactionDelete,
  studentFeeTransactionList,
} from "../../api/Student";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import DownloadExcel from "../master/DownloadExcel";
import { PrintPage } from "../master/Print";
import { BankList } from "../../api/BankService";
import Pagination from "../components/Pagination";
import ReportLayout from "../main/Reports/ReportLayout";

export default function FeeTransactions() {
  const hasAccess = usePrivateLink();
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const [totleAmount, setTotleAmount] = useState(0);

  const [banks, setBanks] = useState([]);

  const today = new Date();
  const [filters, setFilters] = useState({
    start_date: formatDate(new Date(today.getFullYear(), today.getMonth(), 2)),
    end_date: formatDate(today),
  });

  const getDataList = async () => {
    setLoading(true);
    let addUrl = "";
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value) {
        addUrl += `&${key}=${encodeURIComponent(value)}`;
      }
    });
    try {
      const response = await studentFeeTransactionList(addUrl);
      if (response.data.status) {
        setData(response?.data?.data);
        setTotleAmount(response?.data?.total_amount);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This Transaction will be permanently deleted. You cannot undo this action.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (!confirm.isConfirmed) return;

    setLoading(true);
    try {
      const response = await studentFeeTransactionDelete(id);
      if (response.data.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getDataList();
    }
  };

  const getBusinessBanks = async () => {
    setLoading(true);
    try {
      const response = await BankList();
      if (response?.data?.status) {
        setBanks(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDataList();
  }, [filters]);

  useEffect(() => {
    getBusinessBanks();
  }, []);

  const parseModule = (moduleStr) => {
    try {
      const parsed = JSON.parse(moduleStr);
      return parsed.map((m, i) => (
        <div key={i} className="text-nowrap">
          <strong>{m.type}</strong> - ₹{m.amount}
        </div>
      ));
    } catch (e) {
      return "Invalid Data";
    }
  };

  const handleDownload = async (type = "excel") => {
    setLoading(true);
    try {
      const downloadData = [];
      const lastPage = data?.last_page ?? 1;

      for (let page = 1; page <= lastPage; page++) {
        let addUrl = `page=${page}`;
        Object.keys(filters || {}).forEach((key) => {
          const value = filters[key];
          if (value !== undefined && value !== null && value !== "") {
            if (key !== "page") {
              addUrl += `&${key}=${encodeURIComponent(value)}`;
            }
          }
        });

        const response = await studentFeeTransactionList(addUrl);

        if (response?.data?.status) {
          const items = response?.data?.data?.data ?? [];

          const pageRows = items.map((item) => ({
            "Student Name":
              item?.student?.name ??
              item?.library_student?.student_name ??
              item?.hostel_student?.student_name ??
              "",
            "Registration No":
              item?.student?.registration_no ??
              item?.library_student?.registration_no ??
              item?.hostel_student?.registration_no ??
              "",
            "Mobile No":
              item?.student?.phone ??
              item?.library_student?.mobile ??
              item?.hostel_student?.mobile ??
              "",
            "Receipt No": item?.receipt_no ?? "",
            Amount: item?.amount ?? "",
            "Payment Method": item?.payment_method ?? "",
            "Account No": item?.account_no ?? "",
            "Transaction No": item?.transaction_no ?? "",
            "Payment Date": formatToDate(item?.payment_date) ?? "",
            Remark: item?.remark ?? "",
            "Creator By": item?.created_by?.name || "",
            Status: item.status === "1" ? "Success" : ("Pending" ?? ""),
          }));

          downloadData.push(...pageRows);
        } else {
          SweetAlertShow(
            "info",
            "Warning",
            response?.data?.message ?? "No data",
          );
          break;
        }
      }

      if (downloadData.length > 0) {
        if (type === "excel") {
          const now = new Date();
          const fileName = `Report_${now.getFullYear()}-${
            now.getMonth() + 1
          }-${now.getDate()}_${now.getHours()}-${now.getMinutes()}-${now.getSeconds()}`;
          DownloadExcel(downloadData, [], fileName, []);
        } else {
          PrintPage(downloadData);
        }
      } else {
        SweetAlertShow("info", "Info", "No records found to download.");
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message ?? "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {" "}
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row ">
                  <ReportLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-6">
                            <h4 className="text-primary m-0">
                              Fee Transactions
                            </h4>
                          </div>
                          <div className="col-6 d-flex align-items-center justify-content-end gap-2">
                            {hasAccess("/student/fee/transactions/export") && (
                              <button
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => handleDownload("excel")}
                              >
                                <i className="ri-file-excel-2-line ri-26px"></i>
                              </button>
                            )}
                            {hasAccess("/student/fee/transactions/print") && (
                              <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => handleDownload("print")}
                              >
                                <i className="ri-printer-line ri-26px"></i>
                              </button>
                            )}
                          </div>
                          <div className="col-12">
                            <hr />
                          </div>
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="date"
                                name="start_date"
                                id="start_date"
                                className="form-control"
                                value={filters?.start_date}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    start_date: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="start_date"> From Date</label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="date"
                                name="end_date"
                                id="end_date"
                                className="form-control"
                                value={filters?.end_date}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    end_date: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="end_date">To Date</label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-6">
                              <select
                                name="bank_id"
                                id="bank_id"
                                className="form-select"
                                value={filters?.bank_id}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    bank_id: e.target.value,
                                  })
                                }
                              >
                                <option value="">All</option>
                                {banks?.map((item) => (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.account_no}:({item?.owner_name})
                                  </option>
                                ))}
                              </select>
                              <label htmlFor="">Select Account</label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline">
                              <input
                                type="text"
                                name="search"
                                id="search"
                                placeholder="Search"
                                className="form-control"
                                value={filters?.search}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    search: e.target.value,
                                  })
                                }
                              />
                              <label htmlFor="search">Search</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body px-2">
                        <div className="d-flex justify-content-between mb-2">
                          <h6>Total Records: {data?.data?.length}</h6>

                          <h6 className="text-primary">
                            Total Amount: ₹ {totleAmount}{" "}
                          </h6>
                        </div>
                        <div className="table-responsive">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Student</th>
                                <th>Receipt</th>
                                <th>Module</th>
                                <th>Amount</th>
                                <th>Payment</th>
                                <th>Bank</th>
                                <th>Date</th>
                                <th>Created By</th>
                                <th>Remark</th>
                                <th>Action</th>
                              </tr>
                            </thead>

                            <tbody>
                              {data?.data?.length > 0 ? (
                                data?.data.map((item, index) => (
                                  <tr key={item.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                      {item?.student_id ? (
                                        <Link
                                          to={`/student/details?id=${item?.student_id}`}
                                        >
                                          {item?.student?.name} (
                                          {item?.student?.registration_no})
                                        </Link>
                                      ) : (
                                        (item?.student?.name ??
                                        item?.library_student?.student_name ??
                                        item?.hostel_student?.student_name ??
                                        "")
                                      )}
                                    </td>
                                    <td>{item.receipt_no}</td>
                                    <td>{parseModule(item.module)}</td>
                                    <td className="fw-bold text-success">
                                      ₹{item.amount}
                                    </td>
                                    <td>
                                      <span
                                        className={`badge ${
                                          item.payment_method === "Cash"
                                            ? "bg-success"
                                            : "bg-primary"
                                        }`}
                                      >
                                        {item.payment_method}
                                      </span>
                                    </td>
                                    <td>
                                      {item.bank ? item?.bank?.account_no : "-"}
                                    </td>
                                    <td>{formatToDate(item.payment_date)}</td>
                                    <td>{item.created_by?.name || "-"}</td>
                                    <td>{item.remark || "-"}</td>
                                    <td>
                                      <div className="d-flex gap-2">
                                        {hasAccess("/student/fees/receipt") && (
                                          <Link
                                            className="btn btn-label-primary"
                                            to={`/student/fees/receipt?id=${item?.id}`}
                                          >
                                            <i className="ri-printer-line ri-20px"></i>
                                          </Link>
                                        )}
                                        {hasAccess(
                                          "/student/fee/transaction/delete",
                                        ) && (
                                          <button
                                            className="btn btn-label-danger"
                                            onClick={() =>
                                              handleDelete(item?.id)
                                            }
                                          >
                                            <i className="ri-delete-bin-line ri-20px"></i>
                                          </button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="9" className="text-center">
                                    No Transactions Found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>

                          <Pagination
                            data={data}
                            setFilters={setFilters}
                            filters={filters}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
